import {MyIsEmail, MyIsNotEmpty} from '../../../form-validation/decorators';

export class EmailForm {
  @MyIsNotEmpty()
  @MyIsEmail()
  email = '';
}
